/**
 * Referral persistence — captures ?ref=CODE from the URL on any page and stores it in
 * sessionStorage so it survives navigation + login. CODE is a short human referral code
 * (e.g. "John4821") or a discount promo code (e.g. "JOHNSPRING"). Sent with checkout.
 * (Legacy raw-UUID links still resolve server-side for backward compatibility.)
 */
const KEY = "elev650_referrer_code";
const AT_KEY = "elev650_referrer_at";

export function captureReferralFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref && /^[A-Za-z0-9-]{3,40}$/.test(ref)) {
      sessionStorage.setItem(KEY, ref);
      sessionStorage.setItem(AT_KEY, new Date().toISOString());
      params.delete("ref");
      const newSearch = params.toString();
      const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : "") + window.location.hash;
      window.history.replaceState({}, "", newUrl);
    }
  } catch (_) {}
}

export function getReferrerId() {
  try { return sessionStorage.getItem(KEY) || null; } catch { return null; }
}

export function getReferrerCapturedAt() {
  try { return sessionStorage.getItem(AT_KEY) || null; } catch { return null; }
}

export function setReferrerCode(code) {
  try {
    if (code) {
      sessionStorage.setItem(KEY, code);
      sessionStorage.setItem(AT_KEY, new Date().toISOString());
    }
  } catch (_) {}
}

export function clearReferrer() {
  try { sessionStorage.removeItem(KEY); sessionStorage.removeItem(AT_KEY); } catch (_) {}
}
